import axios from '../../axios';

// initial state
const state = {
    list: [
        // { id: xx, code: 'r-amepla', name: 'amepla', type_id: 'rakuten'}
    ],
    malls: [
        { id: 'rakuten', name: '楽天' },
        { id: 'yahoo', name: 'Yahoo' },
        { id: 'amazon', name: 'Amazon' },
        { id: 'wowma', name: 'Wowma' }
    ],
    // 店舗一覧（バックエンドの tempo_code_settings ベースAPIから取得）
    // [{ service_id, id(service_code), name }]（display_sort順）
    shops: []
};

// getters
const getters = {
    all: (state, getters) => {
    // TODO: state.listとstate.mallsから作成する
    return [
        ...getters.allByGroup.inHouses.map(inHouse => {
        // TODO: Datable.vueになかったのでtype_id一旦なし
        return { ...inHouse, type_id: null, type_name: null };
    }),
    ...getters.allByGroup.malls
        .map(mall =>
            mall.services.map(service => {
            return {
                id: service.id,
                name: service.name,
                type_id: mall.id,
                type_name: mall.name
            };
        })
    )
        .flat(),
      ...getters.allByGroup.shops
        .map(shop =>
          shop.services.map(service => {
            return {
              id: service.id,
              name: service.name,
              type_id: shop.id,
              type_name: shop.name
            };
          })
        )
        .flat()
    ];
  },
  allByGroup: state => {
        state;
        // TODO: state.listとstate.mallsから作成する
        // TODO: Datable.vueの表示に合わせたので、stateにするには調整必要
        return {
            inHouses: [
                {
                    id: 'amepla',
                    name: 'amepla',
                    services: [{ id: 'amepla', name: 'amepla', service_id: 30 }],
                    no: 2
                },
                {
                    id: 'nelture',
                    name: 'Nelture',
                    services: [{ id: 'nelture', name: 'nelture', service_id: 35 }],
                    no: 3
                },
                {
                    id: 'ametore',
                    name: 'AZBS',
                    services: [{ id: 'ametore', name: 'ametore', service_id: 33 }],
                    no: 4
                }
            ],
            malls: [
                {
                    id: 'rakuten',
                    name: '楽天',
                    services: [
                        { id: 'r-amepla', name: 'amepla', service_id: 4, no: 6 },
                        { id: 'r-nelture', name: 'ネルチャー', service_id: 10, no: 7 }
                    ],
                    no: 5
                },
                {
                    id: 'yahoo',
                    name: 'Yahoo',
                    services: [
                      { id: 'y-ibiki', name: 'アメプラ＆ネルチャー', service_id: 26, no: 8 }
                    ]
                },
                {
                  id: 'amazon',
                  name: 'Amazon',
                  services: [
                    { id: 'amazon-beauty_plus', name: 'amepla公式店', service_id: 28, no: 9 }
                  ]
                },
                {
                  id: 'zozo',
                  name: 'ZOZO',
                  services: [
                    { id: 'z-amepla', name: 'amepla', service_id: 55, no: 10 }
                  ]
                }
            ],

            //画面表示順（店舗は tempo_code_settings ベースAPIから取得した state.shops を使用）
            //noはモール最大(10)・店舗グループ(11)の次の12から順に採番する
            shops: [
                {
                  id: 'shop',
                  name: '店舗',
                  services: state.shops.map((shop, index) => ({
                    id: shop.id, // service_code
                    name: shop.name,
                    service_id: shop.service_id,
                    no: 12 + index
                  })),
                  no: 11
                }
            ]
        };
  }
};

// actions
const actions = {
  // 店舗一覧を tempo_code_settings ベースのAPIから取得する
  fetchShops: async function(context) {
    const res = await axios.get('/api/service/shops');
    context.commit('setShops', res.data);
  }
};

// mutations
const mutations = {
  set(state, value) {
    state.list = value;
  },
  setShops(state, value) {
    state.shops = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
